if(!customElements.get('hoculus-recently-viewed-articles')) {
  class HoculusRecentlyViewedArticles extends HTMLElement {
    constructor() {
      super();
      this.wrapperArticles = this.querySelector('.recently-viewed-articles-container');
      this.cardTemplate = this.querySelector('.recently-viewed-article-card-template');
      this.activeArticle = JSON.parse(this.dataset.article) || {};
      this.maxArticleItems = parseInt(this.dataset.maxArticlesItems) || 3;
      this.recentlyViewedArticles = JSON.parse(localStorage.getItem('recentlyViewedArticles') || '[]');

      this.syncRecentlyViewedArticles();
      this.handleVisibility();
    }


    syncRecentlyViewedArticles() {
        this.recentlyViewedArticles = this.recentlyViewedArticles.filter(article => article.handle !== this.activeArticle.handle);
        this.recentlyViewedArticles.unshift(this.activeArticle);

        this.recentlyViewedArticles = this.recentlyViewedArticles.slice(0, this.maxArticleItems);
        localStorage.setItem('recentlyViewedArticles', JSON.stringify(this.recentlyViewedArticles));
        this.render();
    }

    handleVisibility() {
      this.classList.toggle('d-none', this.recentlyViewedArticles.filter(article => article.handle !== this.activeArticle.handle).length === 0);
    }

    createArticleCardElement(article) {
        const cardElement = this.cardTemplate.content.firstElementChild.cloneNode(true);
        const titleElement = cardElement.querySelector('.js-article-title');
        const imageElement = cardElement.querySelector('.js-article-image');
        const linkElement = cardElement.querySelector('.js-article-link');

        titleElement.textContent = article.title || '';
        linkElement.href = article.url || '#';
        imageElement.src = article.image || '';
        imageElement.alt = article.title || '';

        return cardElement;
    }

    render() {
      this.wrapperArticles.innerHTML = '';
      this.handleVisibility();
      const articlesFragment = document.createDocumentFragment();

      this.recentlyViewedArticles
        .filter(article => article.handle !== this.activeArticle.handle)
        .forEach(article => {
        const articleCardElement = this.createArticleCardElement(article);
        if(articleCardElement) {
          articlesFragment.appendChild(articleCardElement);
        }
      });

      this.wrapperArticles.appendChild(articlesFragment);
    }
  }
  
  customElements.define('hoculus-recently-viewed-articles', HoculusRecentlyViewedArticles);
}